import React from 'react'
import { useNavigate } from 'react-router-dom'
import Carousel, { CarouselItem } from 'components/Common/Carousel'
import { useDispatch, useSelector } from 'react-redux'

import Navbar from 'components/Common/Navbar'
import TextField from 'components/Common/TextField'
import Button from 'components/Common/Button'

import actionTypes from 'store/actions'
import { PRIMARY_BUTTON } from 'themes/theme'
import carousel1 from 'assets/walkthrough/carousel1.svg'
import carousel2 from 'assets/walkthrough/carousel2.svg'
import carousel3 from 'assets/walkthrough/carousel3.svg'
import carousel4 from 'assets/walkthrough/carousel4.svg'
import './index.css'

const Walkthrough = props => {
  const dashboardInfo = useSelector(state => state.apiResponseReducers.dashboardInfo)
  const accountCodatConnected = useSelector(state => state.appReducer.accountCodatConnected)
  const codatIntegrated = useSelector(state => state.apiResponseReducers.codatIntegrated)
  const companyId = useSelector(state => state.apiResponseReducers.companyId)
  const commerceCodatConnected = useSelector(state => state.appReducer.commerceCodatConnected)
  const userInfo = useSelector(state => state.userReducer)
  const isFreeAccount = userInfo?.user?.accountType !== 'premium'
  const navigate = useNavigate()
  const dispatch = useDispatch()

  // console.log('selectedBusiness-', { dashboardInfo })
  const content = {}
  const isClaimed = dashboardInfo?.business_info?.claimed_business_details?.isClaimed
  if (isClaimed) {
    // claimed user content
    content.carousel1h1 = 'Is your business up-to-date?'
    content.carousel1p1 = 'Let us help you keep your business data correct and ready for you to use.'
    content.carousel1p2 = 'Head into your personal business command center and get started.'
    content.carousel1cta = 'Go to My Business'

    content.carousel2h1 = 'Find trusted vendors and suppliers'
    content.carousel2p1 =
      'Search our Directory of over 100 million pre-verified businesses and follow the partners or suppliers'
    content.carousel2p2 = `you're interested in keeping tabs on.`
    content.carousel2cta = 'Go to Directory'

    content.carousel3h1 = 'Store and manage your key documents'
    content.carousel3p1 =
      'Save the time and the hassle of locating and sharing your sensitive and critical business data'
    content.carousel3p2 = 'when qualifying for a loan, line of credit, insurance, rental space, and more.'
    content.carousel3cta = 'Go to Vault'

    content.carousel4h1 = 'Link your favorite apps'
    content.carousel4p1 = `Monitor cashflow, payments, and sales by integrating your financial apps. You'll now get a`
    content.carousel4p2 = 'streamlined view of your sales, transactions, supplier payments, payables, and receivables.'
    content.carousel4cta = 'Connect Apps'

    if (isFreeAccount) {
      content.carousel4h1 = 'Link your favorite apps'
      content.carousel4p1 = `Monitor cashflow, payments, and sales by integrating your financial apps. You'll now get a`
      content.carousel4p2 = `streamlined view of your sales, transactions, supplier payments, payables, and receivables.`
      content.carousel4cta = 'Go to Dashboard'
    }
  } else {
    // free user content

    content.carousel1h1 = 'Your business command center'
    content.carousel1p1 = 'Keep your small business ready for your next growth move.'
    content.carousel1p2 = 'Monitor, manage and update your business data right here.'
    content.carousel1cta = 'Claim Your Business'

    content.carousel2h1 = 'Find trusted vendors and suppliers'
    content.carousel2p1 =
      'Search our Directory of over 100 million pre-verified businesses and follow the partners or suppliers'
    content.carousel2p2 = `you're interested in keeping tabs on.`
    content.carousel2cta = 'Go to Directory'

    content.carousel3h1 = 'Store and manage your key documents'
    content.carousel3p1 =
      'Save the time and the hassle of locating and sharing your sensitive and critical business data'
    content.carousel3p2 = 'when qualifying for a loan, line of credit, insurance, rental space, and more.'
    content.carousel3cta = 'Go to Vault'

    content.carousel4h1 = 'Link your favorite apps'
    content.carousel4p1 = `Monitor cashflow, payments, and sales by integrating your financial apps. You'll now get a`
    content.carousel4p2 = 'streamlined view of your sales, transactions, supplier payments, payables, and receivables.'
    content.carousel4cta = 'Connect Apps'

    if (isFreeAccount) {
      content.carousel4h1 = 'Link your favorite apps'
      content.carousel4p1 = `Monitor cashflow, payments, and sales by integrating your financial apps. You'll now get a`
      content.carousel4p2 = `streamlined view of your sales, transactions, supplier payments, payables, and receivables.`
      content.carousel4cta = 'Go to Dashboard'
    }
  }

  const handleCtaRedirection = ctaName => {
    // claimed user cta's
    if (ctaName === 'Claim Your Business') {
      // should take user to the “Profile” tab of the “Claimed Business” pages.
      navigate('/find')
    }
    if (ctaName === 'Go to My Business') {
      // should take user to the “Profile” tab of the “Claimed Business” pages.
      navigate('/correct-your-data')
    }
    if (ctaName === 'Go to Directory') {
      // should take user to the “Find a Business” landing page.
      navigate('/find')
    }
    if (ctaName === 'Go to Vault') {
      // should take user to the “Manage Vault” landing page.
      navigate('/vault-verification')
    }
    if (ctaName === 'Connect Apps' || ctaName === 'Go to Dashboard') {
      // should take user to the “codate flow” or home page
      if (isFreeAccount) {
        // dispatch({ type: actionTypes.TOGGLESUBSCRIPTIONMODAL, data: true })
        navigate('/')
      } else {
        if (codatIntegrated) {
          if (accountCodatConnected && !commerceCodatConnected) {
            window.location.replace(`https://links.codat.io/company/${companyId}/link/commerce`)
          } else if (commerceCodatConnected && !accountCodatConnected) {
            window.location.replace(`https://links.codat.io/company/${companyId}/link/accounting`)
          } else {
            window.location.replace(`https://links.codat.io/company/${companyId}`)
          }
        } else {
          dispatch({ type: actionTypes.TOGGLECOMPANYNAMEMODAL, data: true })
          navigate('/')
        }
      }
    }
  }

  if (!('claimed_business_details' in dashboardInfo?.business_info || {})) return <></>

  return (
    <div className="walkthrough-wrapper">
      <Navbar />
      <div className="custom-carousel-wrapper">
        <Carousel>
          <CarouselItem>
            <div className="custom-curousel-body">
              <div className="image-wrapper">
                <img src={carousel1} alt="slider1" />
              </div>
              <div className="content-wrapper">
                <h1>{content.carousel1h1}</h1>
                <p>
                  {content.carousel1p1}
                  <br />
                  {content.carousel1p2}
                </p>
              </div>
              <div className="cta-wrapper">
                {!dashboardInfo?.business_info?.claimed_business_details?.isClaimed ? (
                  <>
                    <TextField
                      placeholder="Business Name"
                      size="small"
                      name="businessName"
                      error={false}
                      // value={data.businessName}
                      // onChange={handleInput}
                    />
                    <TextField
                      placeholder="Location"
                      size="small"
                      name="businessName"
                      error={false}
                      // value={data.businessName}
                      // onChange={handleInput}
                    />
                  </>
                ) : null}
                <Button type={PRIMARY_BUTTON} onClick={() => handleCtaRedirection(content.carousel1cta)}>
                  {content.carousel1cta}
                </Button>
              </div>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div className="custom-curousel-body">
              <div className="image-wrapper">
                <img src={carousel2} alt="slider1" />
              </div>
              <div className="content-wrapper">
                <h1>{content.carousel2h1}</h1>
                <p>
                  {content.carousel2p1}
                  <br />
                  {content.carousel2p2}
                </p>
              </div>
              <div className="cta-wrapper">
                <Button type={PRIMARY_BUTTON} onClick={() => handleCtaRedirection(content.carousel2cta)}>
                  {content.carousel2cta}
                </Button>
              </div>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div className="custom-curousel-body">
              <div className="image-wrapper">
                <img src={carousel3} alt="slider1" />
              </div>
              <div className="content-wrapper">
                <h1>{content.carousel3h1}</h1>
                <p>
                  {content.carousel3p1}
                  <br />
                  {content.carousel3p2}
                </p>
              </div>
              <div className="cta-wrapper">
                <Button type={PRIMARY_BUTTON} onClick={() => handleCtaRedirection(content.carousel3cta)}>
                  {content.carousel3cta}
                </Button>
              </div>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div className="custom-curousel-body">
              <div className="image-wrapper">
                <img src={carousel4} alt="slider1" />
              </div>
              <div className="content-wrapper">
                <h1>{content.carousel4h1}</h1>
                <p>
                  {content.carousel4p1}
                  <br />
                  {content.carousel4p2}
                </p>
              </div>
              <div className="cta-wrapper">
                <Button type={PRIMARY_BUTTON} onClick={() => handleCtaRedirection(content.carousel4cta)}>
                  {content.carousel4cta}
                </Button>
              </div>
            </div>
          </CarouselItem>
        </Carousel>
      </div>
    </div>
  )
}

export default Walkthrough
